import { forwardRef } from 'react'
import { BoardButton, BoardButtonLink, ButtonPendingGlyph, PendingButtonLabel } from '../../boardui/Button'
import { resolveComponentVariant } from '../componentContract'

const variants = ['primary', 'secondary', 'ghost', 'danger']
const sizeAliases = { sm: 'compact', md: 'default', lg: 'large', xl: 'large' }
const sizes = ['compact', 'default', 'large']

function resolveSize(size) {
  const normalized = sizeAliases[size] || size
  return resolveComponentVariant('Button size', normalized, sizes, 'default')
}

export const Button = forwardRef(function Button({
  variant = 'primary', size = 'default', loading = false, children,
  className = '', disabled = false, type = 'button', ...rest
}, ref) {
  const resolvedVariant = resolveComponentVariant('Button variant', variant, variants, 'primary')
  const resolvedSize = resolveSize(size)
  return (
    <BoardButton
      {...rest}
      ref={ref}
      variant={resolvedVariant}
      size={resolvedSize}
      className={className}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      leading={loading ? <ButtonPendingGlyph /> : undefined}
    >
      {loading ? <PendingButtonLabel>{children}</PendingButtonLabel> : children}
    </BoardButton>
  )
})

export const LinkButton = forwardRef(function LinkButton({
  variant = 'primary', size = 'default', disabled = false, children,
  className = '', onClick, ...rest
}, ref) {
  const resolvedVariant = resolveComponentVariant('LinkButton variant', variant, variants, 'primary')
  const resolvedSize = resolveSize(size)
  return (
    <BoardButtonLink
      {...rest}
      ref={ref}
      variant={resolvedVariant}
      size={resolvedSize}
      className={className}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : rest.tabIndex}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault()
          return
        }
        onClick?.(event)
      }}
    >
      {children}
    </BoardButtonLink>
  )
})
